import { get, writable } from 'svelte/store';

export type SettingsRouteIntent = {
	initiate?: boolean;
};

export const settingsRouteIntent = writable<SettingsRouteIntent | null>(null);

export function isSettingsRouteInitiate(params: unknown): boolean {
	return (
		typeof params === 'object' &&
		params !== null &&
		!Array.isArray(params) &&
		(params as SettingsRouteIntent).initiate === true
	);
}

export function consumeSettingsRouteIntent(): SettingsRouteIntent | null {
	const intent = get(settingsRouteIntent);
	if (intent) settingsRouteIntent.set(null);
	return intent;
}

const createRouteToDeviceSettings = () => {
	//store for routing to every device drawer setting + sub setting
	// for example: go to Firmware version -> send device id, 'settings', 'firmware_version'
	// check all settings & subSettings in device_config
	const { subscribe, set, update } = writable({});

	return {
		subscribe,
		setTarget: (id, setting, subSetting = '', params = '') => {
			update((settings) => {
				settings[id] = {
					setting: setting,
					subSetting: subSetting,
					params: params,
				};
				return settings;
			});
		},
		resetTarget: () => set({}),
	};
};

export const routeToDeviceSettings = createRouteToDeviceSettings();
